export default __webpack_public_path__ + "static/media/robot-red.a34b1d0b.svg";